import Dialog from "./Dialog";

/**
 * @class InfoDialog
 */
export default class InfoDialog extends Dialog {
    /**
     * @param   {Number}        id
     * @param   {String}        type
     * @param   {String}        text
     * @param   {Number}        message
     * @param   {String}        messageCode
     * @param   {Number}        icon
     * @param   {Array}         buttons
     * @param   {Array}         params
     * @param   {Object}        meta
     * @param   {String | null} description
     */
    constructor(id, type, text, message, messageCode, icon, buttons, params, meta, description) {
        super(id, type, text, message, messageCode, icon, buttons, params, meta);

        this._description = description;
    }

    /**
     * @param   {String | null} description
     */
    set description(description) {
        this._description = description;
    }

    /**
     * @return {String | null}
     */
    get description() {
        return this._description;
    }

    /**
     * Clones dialog object.
     *
     * @return  {Object}
     */
    clone = () => {
        return new InfoDialog(
            this._id,
            this._type,
            this._text,
            this._message,
            this._messageCode,
            this._icon,
            this._buttons,
            this._params,
            this._meta,
            this._description
        );
    };
}
